import type { JournalArticle } from '@/types'
import { unsplash, imageIds } from '@/lib/images'

export const journalArticles: JournalArticle[] = [
  {
    slug: 'how-fragrance-dries-down',
    title: 'How a Fragrance Dries Down',
    excerpt: 'Why the first spray never tells the full story — and what top, heart, and base notes actually mean for your skin.',
    readTime: 5,
    image: unsplash(imageIds.texture1, 900, 600),
    publishedAt: '2026-09-15',
    body: `A fragrance is a time-lapse. The molecules that rise first are the lightest: citrus, herbs, and airy aromatics. They form the top notes, the handshake of the scent.

Within minutes, the heart notes emerge. These are often florals, spices, or fruits, and they define the personality of the fragrance for most of its life.

Hours later, the base notes settle. Woods, resins, vanilla, musk — these are the slowest to evaporate and the last to linger on your collar.

Skin chemistry, weather, and even what you ate can shift the timeline. That is why sampling before committing is the oldest rule in perfumery.`,
  },
  {
    slug: 'scent-memory',
    title: 'Scent, Memory, and the Invisible Archive',
    excerpt: 'The science behind why a single note can transport you back to a room you have not entered in years.',
    readTime: 4,
    image: unsplash(imageIds.texture2, 900, 600),
    publishedAt: '2026-08-22',
    body: `The olfactory bulb sits close to the amygdala and hippocampus, the brain's emotional and memory centers. This is why smell triggers recall faster than sight or sound.

Perfumers exploit this architecture. A hint of jasmine might recall a summer garden; a trace of smoke, a winter fireplace. When we choose a fragrance, we are not just picking a scent — we are choosing what we want to remember and be remembered by.`,
  },
  {
    slug: 'refill-ritual',
    title: 'The Refill Ritual',
    excerpt: 'Refilling your bottle saves plastic, preserves the bottle you love, and costs less than a new purchase.',
    readTime: 3,
    image: unsplash(imageIds.lifestyle2, 900, 600),
    publishedAt: '2026-07-30',
    body: `Our 50ml and 100ml bottles are designed to last years. When you finish one, order a refill pouch instead of replacing the glass. We ship the same formula in a lower-impact pouch, you decant it at home, and we credit the savings back to you.

It is a small ritual, but over the lifetime of a fragrance it matters.`,
  },
]

export function getJournalArticleBySlug(slug: string): JournalArticle | undefined {
  return journalArticles.find((a) => a.slug === slug)
}
